import $ from 'jquery';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
import {PluginRunner} from '../../../jsmod/js/registerPlugin';

export class FormSubmit {
  public static frontend(el: HTMLElement, opt: any) {
    return new this($(el));
  }

  public static cleanup(instance: FormSubmit) {
    instance.$elem.find('[type="file"]').off('change');
    instance.$elem.find('form').off('submit');
  }
  public files: any;

  constructor(public $elem: JQuery, public updateHook?) {
    $elem.find('[type="file"]').change((e: InputEvent) => {
      // tslint:disable-next-line:no-string-literal
      this.files = e.target['files'];
    });

    const $thisForm = $elem.find('form');
    const $errors = $elem.find('label span.error-msg.server');
    if ($errors.length > 0) {
      $errors.get(0).scrollIntoView({behavior: 'smooth'});
    }
    $thisForm.find('input[type=submit]').on('click', (e) => {
      $(e.target).attr('clicked', 'true');
    });
    $thisForm.on('submit', (e) => {
      e.preventDefault();
      const $id = $(e.target).parents('.me-Form').attr('data-formId');
      const $submitButton = $thisForm.find('[clicked="true"]');
      const formData = new FormData();
      const $input = $elem.find('form :input');
      $input.each((index, el) => {
        const $this = $(el);
        if ($this.attr('type') === 'file' && this.files) {
          formData.append($this.attr('name'), this.files[0]);
        } else if (
          $this.attr('type') === 'checkbox' ||
          $this.attr('type') === 'radio'
        ) {
          if ($this.prop('checked')) {
            formData.append($this.attr('name'), $this.val());
          }
        } else if (
          $this.attr('type') === 'submit' ||
          $this.prop('tagName') === 'BUTTON'
        ) {
        } else {
          formData.append($this.attr('name'), $this.val());
        }
      });
      if ($submitButton.children().length > 0) {
        formData.append(
          $submitButton.children().attr('name'),
          $submitButton.children().val(),
        );
      } else {
        formData.append($submitButton.attr('name'), $submitButton.val());
      }
      $submitButton.removeAttr('clicked');
      const urlQuery = $elem.attr('data-url').split('?', 2);
      const baseUrl = urlQuery[0];
      let query = urlQuery.length === 2 ? urlQuery[1] : '';
      if (window.location.search.length > 0) {
        if (query.length > 0) {
          query += '&';
        }
        query += window.location.search.substr(1);
      }
      const url = `${baseUrl}${query.length > 0 ? `?${query}` : ''}`;
      const xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      xhr.setRequestHeader('X-Soft-Redirect', 'on');
      const id = $elem.attr('id');
      xhr.onload = () => {
        if (xhr.status === 200 || xhr.status === 401) {
          const newLocation = xhr.getResponseHeader('X-Location');
          if (newLocation) {
            window.location.href = newLocation;
            return;
          }
          try {
            const newEl: HTMLElement = $(xhr.response).find(`#${id}`).get(0);
            PluginRunner.getInstance().replaceEl($elem.get(0), newEl);
            scrollIntoView(newEl, {
              scrollMode: 'if-needed',
              behavior: 'smooth',
            });
          } catch (e) {
            window.location.replace(xhr.responseURL);
          }
          // if (window.grecaptcha) {
          // const $reCaptcha = $elem.find('.g-recaptcha');
          // if ($reCaptcha.length > 0) {
          //   const $id = $reCaptcha.attr('id');
          //   window.grecaptcha.render($id);
          // }
          // }
        } else {
          console.error(xhr);
        }
      };

      xhr.send(formData);
      // $.ajax({
      //   url,
      //   method: 'POST',
      //   data: formData,
      //   cache: false,
      //   processData: false,
      //   contentType: false,
      // }).done((res) => {
      //   // const $form = $(res).find('me-Form');
      //   // const hasForm = $form.length > 0 && $form.attr('data-formId') === $id;
      //   // if (hasForm) {
      //   //   $thisForm.empty().append($(res).find('form').children().unwrap());
      //   // } else
      //   //   $thisForm.empty().append($(res).find(`#${id}`).html());
      // }).fail((err) => {
      //   console.log('Failed to submit form with error: ', err);
      // });
    });
  }
}
